module.exports = __webpack_public_path__ + "static/img/14055BN_2_R_20201107_LC.6c77b88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14055BN_2_R_20201107_LC.png
// module id = wSs4
// module chunks = 0